import { INITIAL_LOAD } from 'constants/network-status'

export const buildPayload = (apolloResponse: any = {}) => {
  return {
    ...apolloResponse,
    isInitialLoad: apolloResponse.networkStatus === INITIAL_LOAD,
  }
}
